import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography
} from "@mui/material";
import http from "../../commonFunctions/httpClient";
import { useSnackbar } from "../Snackbar/SnackBarContext";

interface ConfirmationPopupProps {
  apiUrl: string;
  id: string | number;
  confirmMessage: string;
  subtitle?:string;
  onConfirm?: (data: any) => void;
  onCancel?: () => void;
  open: boolean;
  onClose: () => void;
  permanent?: boolean;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  apiUrl,
  id,
  confirmMessage,
  subtitle,
  onConfirm,
  onCancel,
  open,
  onClose,
  permanent
}) => {
  const {showMessage} = useSnackbar();
  
  const handleSoftDelete = async () => {
    try {
      const response: any = await http.put(apiUrl + "/" + id, {});
      if (onConfirm) onConfirm(response);
    } catch (error:any) {
      console.error("Error deleting:", error);
      if (error.message === 'GlobalHandledError') return;
        showMessage(error.response?.data?.message || "An unexpected error occurred","error");
    } finally {
      onClose();
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const response: any = await http.del(apiUrl + "/" + id, {});
      if (onConfirm) onConfirm(response);
    } catch (error:any) {
      console.error("Error deleting:", error);
      if (error.message === 'GlobalHandledError') return;
        showMessage(error.response?.data?.message || "An unexpected error occurred","error");
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: 2,
          minWidth: 360,
        },
      }}
    >
      <DialogTitle sx={{ pb: 0, fontWeight: 600 }}>{"Delete Confirmation"}</DialogTitle>

      {subtitle && (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{ px: 3, pt: 0.5 }}
        >
          {subtitle}
        </Typography>
      )}

      <DialogContent sx={{ pt: 2 }}>
        <DialogContentText>{confirmMessage}</DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onCancel || onClose}
          color="inherit"
          variant="outlined"
        >
          No
        </Button>
        <Button
          onClick={permanent ? handleConfirmDelete : handleSoftDelete}
          color="warning"
          variant="contained"
          sx={{
            backgroundColor: "#4DD26B",
            textTransform: "none",
            "&:hover": { backgroundColor: "#3ea856" },
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
